import tools from '../../../../assets/javascript/tools.js'
export default {
    columns: {
        staffName: {
            label: "店员姓名",
            visible: true,
            width: "auto",
            align: "left",
        },
        thingName: {
            label: "物品名称",
            visible: true,
            width: "auto",
            align: "left",
        },
        backStatus: {
            label: "借领状态",
            visible: true,
            width: "auto",
            align: "left",
        },
        borrowTypeCn: {
            label: "借领类型",
            visible: true,
            width: "auto",
            align: "left",
        },
        createTime: {
            label: "借领日期",
            visible: true,
            formatDay: true,
            width: "auto",
            align: "left",
        },
    },
};